import {PopoutCard} from '../../../../popout_card'
import {TableText} from '../components'
import {BaseCollapsibleCell} from './base'
import {getCellComponent} from './get_cell_component'

export const UngroupedCollapsibleCell = ({cell}) => {
	const Component = getCellComponent(cell, DefaultCell)

	return <BaseCollapsibleCell Component={Component} cell={cell} />
}

const DefaultCell = props => {
	const {column, row} = props
	const {columnDef} = column
	const {cell, aggregatesFn, collapsibleCell, format} = columnDef
	const {subRows} = row
	const {id: columnName} = column
	const subRowValues = subRows.map(row => row.getValue(columnName))
	const booleanCell = cell === 'BooleanCell' || collapsibleCell === 'boolean'
	const uniqSubRowAmt = subRowValues.uniq().length
	const showSingleValue = booleanCell || uniqSubRowAmt === 1
	const sumValues = aggregatesFn === 'sumValues'

	let label = sumValues ? subRowValues.sum() : uniqSubRowAmt

	let formattedValue
	if (booleanCell) {
		formattedValue = toBooleanFormat(subRowValues)
	} else if (format) {
		formattedValue = format(subRowValues.sum())
		label = formattedValue
	} else if (sumValues) {
		formattedValue = subRowValues.sum()
	} else {
		formattedValue = toItemFormat(subRowValues)
	}

	if (showSingleValue) return <TableText children={formattedValue} />

	return (
		<PopoutCard
			className="show-more"
			title={formattedValue}
			children={label}
			layoutProps={{width: '100%', overflow: 'hidden'}}
			wrapperLayoutProps={{width: '100%'}}
		/>
	)
}

const toBooleanFormat = items => {
	const trueAmt = items.reduce((count, item) => {
		return item && item !== 'no' ? count + 1 : count
	}, 0)
	const totalAmt = items.length
	return `${trueAmt} / ${totalAmt}`
}

const toItemFormat = (items = []) => {
	items = items.flat().filter(Boolean).uniq()

	// If there is only one, single integer passed, this is an ID. Since we won't transform them to names through records,
	// simply show the count "1", which' value the user may see when expanding the collapsed row.
	if (items.length === 1 && typeof items[0] === 'number') return 1

	const stringifiedItems = items
		.map(item => {
			switch (typeof item) {
				case 'string':
					return item
				case 'object':
					return item.name || item.naam
				default:
					return null
			}
		})
		.filter(Boolean)

	// In case of many items, e.g. team names, make sure only unique values are shown.
	// The first `join` flattens all nested formatted strings.
	return stringifiedItems.join(', ').split(', ').uniq().sort().join(', ')
}
